/* Shared cart classification. Pure functions are also exercised by Node tests. */
(function(root,factory){var api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.FTOrderCart=api;})(typeof window!=='undefined'?window:this,function(){
  var ids={'47537209803054':'front','52020797309230':'large_front','47537209901358':'back','52394261348654':'left_sleeve','52394261512494':'right_sleeve'};
  var names={front:'Left chest',large_front:'Large front',back:'Back',left_sleeve:'Left sleeve',right_sleeve:'Right sleeve'};
  function printType(item){return ids[String(item.variant_id||item.id)]||null;}
  function placements(item){
    var p=item.properties||{},result=[];
    if(p._ft_print_locations){try{return JSON.parse(p._ft_print_locations).filter(function(x){return names[x];});}catch(e){}}
    var text=String(p['T-Shirt Print Location']||p['Print Locations']||p['_Print Locations']||p['Print Location']||'').toLowerCase();
    if(/left.?chest|front left|\bchest\b/.test(text))result.push('front');
    if(/large front|front full|front centre|front center/.test(text))result.push('large_front');
    if(/back/.test(text))result.push('back');
    if(/left sleeve/.test(text))result.push('left_sleeve');
    if(/right sleeve/.test(text))result.push('right_sleeve');
    [['Front print','front'],['Large Front print','large_front'],['Back print','back']].forEach(function(pair){if(String(p[pair[0]]).toLowerCase()==='included'&&result.indexOf(pair[1])<0)result.push(pair[1]);});
    if(!result.length){if(p['Large Front artwork'])result.push('large_front');else if(p['Front artwork'])result.push('front');if(p['Back artwork'])result.push('back');}
    return result;
  }
  function analyse(items){
    var groups={};
    (items||[]).forEach(function(item){
      var p=item.properties||{},type=printType(item),locs=type?[]:placements(item);
      if(!type&&!locs.length)return;
      var key=p._ft_order_group||'legacy';
      var g=groups[key]||(groups[key]={key:key,garments:[],prints:[],expected:{}});
      if(type)g.prints.push(item);else{g.garments.push(item);locs.forEach(function(t){g.expected[t]=(g.expected[t]||0)+item.quantity;});}
    });
    var updates=[],warnings=[],removable=[];
    Object.keys(groups).forEach(function(key){var g=groups[key];Object.keys(names).forEach(function(t){
      var lines=g.prints.filter(function(x){return printType(x)===t;}),expected=g.expected[t]||0,actual=lines.reduce(function(n,x){return n+x.quantity;},0);
      if(expected===actual)return;
      // A new order group has an explicit association. Legacy lines can only
      // be safely adjusted when there is one line for the placement.
      if(lines.length===1&&(key!=='legacy'||expected>0))updates.push({key:lines[0].key,from:actual,to:expected,type:t,title:names[t]+' printing'});
      else{
        // expected===0 here means literally zero garments claim this print
        // type, so every line for it is safe to offer a one-click remove —
        // unlike the expected>0 case (ambiguous quantity/line mismatch),
        // there's no risk of deleting a print a garment still needs.
        var canRemove=expected===0;
        warnings.push(names[t]+': '+actual+' in cart but '+expected+' needed for your garments.'+(canRemove?' You can remove '+(actual===1?'it':'them')+' below.':' Please review your cart.'));
        if(canRemove)removable.push({type:t,keys:lines.map(function(x){return x.key;})});
      }
    });});
    return {groups:Object.keys(groups).map(function(k){return groups[k];}),updates:updates,warnings:warnings,removable:removable};
  }
  function linkedChanges(before, after, changedKey) {
    var changed=(before||[]).find(function(i){return i.key===changedKey;});
    if(!changed||printType(changed)||!placements(changed).length)return [];
    var group=(changed.properties||{})._ft_order_group;
    if(!group)return [];
    var oldGroup=analyse(before).groups.find(function(g){return g.key===group;});
    var newGroup=analyse(after).groups.find(function(g){return g.key===group;});
    var changes=[];
    Object.keys(names).forEach(function(type){
      var lines=(after||[]).filter(function(i){return (i.properties||{})._ft_order_group===group&&printType(i)===type;});
      var expected=newGroup&&newGroup.expected[type]||0;
      var previous=oldGroup&&oldGroup.expected[type]||0;
      var actual=lines.reduce(function(n,i){return n+i.quantity;},0);
      // A deliberate garment edit may adjust an existing correctly paired line.
      // Existing discrepancies can only be reduced, never repaired by adding cost.
      var target=lines.length===1&&actual===previous?expected:Math.min(actual,expected);
      lines.forEach(function(line){var quantity=Math.min(line.quantity,target);if(lines.length===1)quantity=target;target-=quantity;if(quantity!==line.quantity)changes.push({key:line.key,quantity:quantity});});
    });
    return changes;
  }
  return {printType:printType,placements:placements,analyse:analyse,linkedChanges:linkedChanges,names:names};
});
